<div class="filter-container">
  <app-user-list-filter></app-user-list-filter>
</div>
<section class="table-container mat-elevation-z8">
  <table id="user-list" mat-table [dataSource]="isLoading ? skeletonRows : usersDataSource"
    class="mat-elevation-z8 user-table" matSort>
    <ng-container matColumnDef="userId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Användar-Id
      </th>
      <td mat-cell *matCellDef="let element">
        @if(isLoading) {
        <div class="skeleton-line"></div>
        }
        {{ element.userId }}
      </td>
    </ng-container>
    <ng-container matColumnDef="displayName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Namn
      </th>
      <td mat-cell *matCellDef="let element">
        @if(isLoading) {
        <div class="skeleton-line"></div>
        }
        {{ element.displayName }}
      </td>
    </ng-container>
    <ng-container matColumnDef="rolesText">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Roller
      </th>

      <td mat-cell *matCellDef="let element">
        @if(isLoading) {
        <div class="skeleton-line"></div>
        }
        {{ element.rolesText }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</section>